module.exports = __webpack_public_path__ + "3b7fb5a4bc81c916d7714743c9015f39.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/jean-yves-perrier.jpg
// module id = 666
// module chunks = 0